/* FFL Chatbot v9 — externalised from snippets/ffl-chatbot.liquid
   Loaded via <script src="{{ 'ffl-whatsapp.js' | asset_url }}" defer></script>
   Saves ~14KB on every page's HTML; cached by the browser across pages. */
(function(){
'use strict';
var S='https://foreverforlove.com';
var fab=document.getElementById('ffl-fab');
var win=document.getElementById('ffl-win');
var cl=document.getElementById('ffl-close');
var msgs=document.getElementById('ffl-msgs');
var inp=document.getElementById('ffl-inp');
var send=document.getElementById('ffl-send');
var chips=document.getElementById('ffl-chips');
var badge=document.getElementById('ffl-badge');
if(!fab||!win){return;}
var isOpen=false,welcomed=false;

function sc(){msgs.scrollTop=msgs.scrollHeight;}
function addRow(cls){var r=document.createElement('div');r.className='frow '+(cls||'fb');msgs.appendChild(r);return r;}
function bot(text){var r=addRow('fb');var b=document.createElement('div');b.className='fbub';b.innerHTML=text.replace(/\n/g,'<br>');r.appendChild(b);sc();}
function user(text){var r=addRow('fu');var b=document.createElement('div');b.className='fbub';b.textContent=text;r.appendChild(b);sc();}

function orDivider(){
  var r=addRow('fb');
  var d=document.createElement('div');d.className='for-divider';
  var sp=document.createElement('span');sp.textContent='or';
  d.appendChild(sp);
  r.appendChild(d);sc();
}

function makeSVG(type){
  var ns='http://www.w3.org/2000/svg';
  var svg=document.createElementNS(ns,'svg');
  svg.setAttribute('width','13');svg.setAttribute('height','13');svg.setAttribute('viewBox','0 0 24 24');
  if(type==='wa'){
    svg.setAttribute('fill','currentColor');
    var p=document.createElementNS(ns,'path');
    p.setAttribute('d','M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z');
    svg.appendChild(p);
  }else if(type==='fb'){
    svg.setAttribute('fill','currentColor');
    var p=document.createElementNS(ns,'path');
    p.setAttribute('d','M12 0C5.373 0 0 5.036 0 11.244c0 3.544 1.793 6.697 4.586 8.745V24l4.184-2.301c1.118.31 2.3.478 3.53.478 6.627 0 12-5.036 12-11.244S18.627 0 12 0zm1.178 15.146l-3.048-3.25-5.955 3.25 6.549-6.95 3.124 3.25 5.878-3.25-6.548 6.95z');
    svg.appendChild(p);
  }else if(type==='em'){
    svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','2');svg.setAttribute('stroke-linecap','round');svg.setAttribute('stroke-linejoin','round');
    var rect=document.createElementNS(ns,'rect');rect.setAttribute('x','2');rect.setAttribute('y','4');rect.setAttribute('width','20');rect.setAttribute('height','16');rect.setAttribute('rx','2');svg.appendChild(rect);
    var path=document.createElementNS(ns,'path');path.setAttribute('d','M2 7l10 7 10-7');svg.appendChild(path);
  }else if(type==='ar'){
    svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','2.5');svg.setAttribute('stroke-linecap','round');svg.setAttribute('stroke-linejoin','round');
    var l=document.createElementNS(ns,'line');l.setAttribute('x1','5');l.setAttribute('y1','12');l.setAttribute('x2','19');l.setAttribute('y2','12');svg.appendChild(l);
    var pl=document.createElementNS(ns,'polyline');pl.setAttribute('points','12 5 19 12 12 19');svg.appendChild(pl);
  }
  return svg;
}

function goLink(url,label,cls){
  var r=addRow('fb');
  var a=document.createElement('a');
  a.className='flink '+(cls||'flink-def');
  a.href=url;a.target='_blank';a.rel='noopener noreferrer';
  a.appendChild(makeSVG('ar'));a.appendChild(document.createTextNode(label));
  r.appendChild(a);sc();
}

function typing(cb){
  var t=document.createElement('div');t.id='ffl-t';t.className='frow fb';
  var w=document.createElement('div');w.className='ftyp';
  w.innerHTML='<div class="fdot"></div><div class="fdot"></div><div class="fdot"></div>';
  t.appendChild(w);msgs.appendChild(t);sc();
  setTimeout(function(){var e=document.getElementById('ffl-t');if(e)e.remove();cb();},500);
}

function setChips(list){
  chips.innerHTML='';
  (list||[]).forEach(function(c){
    var btn=document.createElement('button');
    btn.type='button';
    btn.className='fchip'+(c.cls?' '+c.cls:'');
    if(c.icon){btn.appendChild(makeSVG(c.icon));}
    btn.appendChild(document.createTextNode(c.label));
    btn.addEventListener('click',function(e){e.stopPropagation();handle(c.label,c.action);});
    chips.appendChild(btn);
  });
}

function showContactChannels(){
  bot('Please select your preferred channel and our team will be with you shortly.');
  setChips([
    {label:'WhatsApp',icon:'wa',cls:'fchip-wa',action:'contact-wa'},
    {label:'Messenger',icon:'fb',cls:'fchip-fb',action:'contact-fb'},
    {label:'Email',icon:'em',action:'contact-em'},
    {label:'Back',action:'start'}
  ]);
}

function showWA(){
  var r1=addRow('fb');
  var card=document.createElement('div');card.className='fqr-card';
  var t=document.createElement('div');t.className='fqr-title';t.textContent='Scan to open WhatsApp';card.appendChild(t);
  var img=document.createElement('img');img.src='https://api.qrserver.com/v1/create-qr-code/?size=110x110&data=https://wa.me/message/PAR4DQIMTXHTK1';img.alt='WhatsApp QR';img.width=110;img.height=110;img.loading='lazy';card.appendChild(img);
  var s=document.createElement('div');s.className='fqr-sub';s.textContent='Scan with your phone camera';card.appendChild(s);
  r1.appendChild(card);sc();
  orDivider();
  var r2=addRow('fb');
  var a=document.createElement('a');a.className='flink flink-wa';
  a.href='https://wa.me/message/PAR4DQIMTXHTK1';a.target='_blank';a.rel='noopener noreferrer';
  a.appendChild(makeSVG('wa'));a.appendChild(document.createTextNode(' Chat on WhatsApp'));
  r2.appendChild(a);sc();
  setChips([{label:'Other options',action:'contact'},{label:'Back to menu',action:'start'}]);
}

function showFB(){
  var r1=addRow('fb');
  var card=document.createElement('div');card.className='fqr-card';
  var t=document.createElement('div');t.className='fqr-title';t.textContent='Scan to open Messenger';card.appendChild(t);
  var img=document.createElement('img');img.src='https://api.qrserver.com/v1/create-qr-code/?size=110x110&data=https://m.me/61578335368770';img.alt='Messenger QR';img.width=110;img.height=110;img.loading='lazy';card.appendChild(img);
  var s=document.createElement('div');s.className='fqr-sub';s.textContent='Scan with your phone camera';card.appendChild(s);
  r1.appendChild(card);sc();
  orDivider();
  var r2=addRow('fb');
  var a=document.createElement('a');a.className='flink flink-fb';
  a.href='https://m.me/61578335368770?source=qr';a.target='_blank';a.rel='noopener noreferrer';
  a.appendChild(makeSVG('fb'));a.appendChild(document.createTextNode(' Message on Messenger'));
  r2.appendChild(a);sc();
  setChips([{label:'Other options',action:'contact'},{label:'Back to menu',action:'start'}]);
}

function showEM(){
  var r1=addRow('fb');
  var card=document.createElement('div');card.className='fem-card';
  var t=document.createElement('div');t.className='fem-card-title';t.textContent='Email us anytime';card.appendChild(t);
  var s=document.createElement('div');s.className='fem-card-sub';s.textContent='We typically respond within a few hours';card.appendChild(s);
  r1.appendChild(card);sc();
  orDivider();
  var r2=addRow('fb');
  var a=document.createElement('a');a.className='flink flink-em';
  a.href='mailto:sales@foreverforlove.com';
  a.appendChild(makeSVG('em'));a.appendChild(document.createTextNode(' sales@foreverforlove.com'));
  r2.appendChild(a);sc();
  setChips([{label:'Other options',action:'contact'},{label:'Back to menu',action:'start'}]);
}

var COLS=[
  {label:'Engagement Rings',url:S+'/collections/engagement-rings',shape:false},
  {label:'Wedding Bands',url:S+'/collections/wedding-bands',shape:false},
  {label:'Lab Grown Diamond Rings',url:S+'/collections/lab-grown-diamond-rings',shape:false},
  {label:'Moissanite Rings',url:S+'/collections/moissanite-rings',shape:false},
  {label:'Fine Jewelry',url:S+'/collections/fine-jewelry',shape:false},
  {label:'Ring Upgrade',url:S+'/pages/ring-upgrade-by-forever-for-love',shape:false}
];

function showCollections(){
  bot('How may I assist you today? Please select a category below.');
  var list=COLS.map(function(c){return{label:c.label,action:{col:c.label,url:c.url,shape:c.shape}};});
  list.push({label:'Browse All Rings',action:'all'});
  list.push({label:'Contact Us',icon:'em',action:'contact'});
  setChips(list);
}

function handle(label,action){
  user(label);
  chips.innerHTML='';
  if(action==='start'){typing(function(){showCollections();});return;}
  if(action==='contact'){typing(function(){showContactChannels();});return;}
  if(action==='contact-wa'){typing(function(){showWA();});return;}
  if(action==='contact-fb'){typing(function(){showFB();});return;}
  if(action==='contact-em'){typing(function(){showEM();});return;}
  if(action==='all'){typing(function(){bot('Here is our full ring collection.');goLink(S+'/collections/rings','View All Rings');setChips([{label:'Back to Menu',action:'start'},{label:'Contact Us',action:'contact'}]);});return;}
  if(!action){
    var t=label.toLowerCase();
    if(t.indexOf('ship')!==-1||t.indexOf('deliver')!==-1){typing(function(){bot('We offer complimentary insured shipping on all orders.\n\n🇬🇧 United Kingdom: 2–5 working days\n🌍 International: 5–10 working days\n\nAll orders are fully tracked and insured.');setChips([{label:'Back to Menu',action:'start'},{label:'Contact Us',action:'contact'}]);});return;}
    if(t.indexOf('return')!==-1||t.indexOf('refund')!==-1){typing(function(){bot('We offer a straightforward returns policy. Please see the full details below.');goLink(S+'/policies/refund-policy','View Returns Policy');setChips([{label:'Back to Menu',action:'start'},{label:'Contact Us',action:'contact'}]);});return;}
    if(t.indexOf('klarna')!==-1||t.indexOf('pay later')!==-1){typing(function(){bot('Yes, we offer Klarna at checkout — pay later or split into manageable instalments. Subject to eligibility.');setChips([{label:'Back to Menu',action:'start'},{label:'Contact Us',action:'contact'}]);});return;}
    typing(function(){showContactChannels();});return;
  }
  if(action&&action.col){
    if(action.shape){typing(function(){bot('Which diamond shape do you prefer?');setChips([{label:'Round',action:{url:action.url+'?filter.p.tag=round',label:'Round — '+action.col}},{label:'Oval',action:{url:action.url+'?filter.p.tag=oval',label:'Oval — '+action.col}},{label:'View All Shapes',action:{url:action.url,label:action.col}}]);});return;}
    typing(function(){bot('Here is the collection you selected.');goLink(action.url,'View '+action.col);setChips([{label:'Back to Menu',action:'start'},{label:'Contact Us',action:'contact'}]);});return;
  }
  if(action&&action.url){typing(function(){bot('Here is the collection you selected.');goLink(action.url,action.label||'View Collection');setChips([{label:'Back to Menu',action:'start'},{label:'Contact Us',action:'contact'}]);});return;}
  typing(function(){showContactChannels();});
}

fab.addEventListener('click',function(){
  isOpen=!isOpen;
  win.classList.toggle('open',isOpen);
  badge.style.display='none';
  if(isOpen&&!welcomed){
    welcomed=true;
    try{localStorage.setItem('ffl_opened','1');}catch(e){}
    bot('Welcome to Forever For Love. 💎 How may I assist you today?');
    showCollections();
  }
  if(isOpen)setTimeout(function(){inp.focus();},300);
});
win.addEventListener('click',function(e){e.stopPropagation();});
cl.addEventListener('click',function(e){e.stopPropagation();isOpen=false;win.classList.remove('open');});
send.addEventListener('click',function(){var t=inp.value.trim();if(!t)return;inp.value='';handle(t,null);});
inp.addEventListener('keydown',function(e){if(e.key==='Enter'){var t=inp.value.trim();if(!t)return;inp.value='';handle(t,null);}});
document.addEventListener('click',function(e){if(isOpen&&e.target!==fab){isOpen=false;win.classList.remove('open');}});
try{if(!localStorage.getItem('ffl_opened')){setTimeout(function(){badge.style.display='flex';},3000);}}catch(e){}
})();
